import*as i from"yup";const a=({format:a,required:e})=>({initialValues:{subscriptionEmail:""},enableReinitialize:!0,validateOnChange:!1,validationSchema:i.object().shape({subscriptionEmail:i.string().email(a.email).required(e.email)})});export{a as getFormConfig};
//# sourceMappingURL=form.js.map
